/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Dropdown,
  Input,
  Popover,
  Row,
  Select,
  Modal,
  Table,
  Tooltip,
  Image,
  Typography,
  Skeleton,
} from "antd";
import {
  FileTextOutlined,
  DownOutlined,
  SettingOutlined,
  SearchOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  // ArrowDownOutlined,
  ArrowUpOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import "./index.css";
import { bulkActions, items, vendorHeaders } from "./data";
import customModalLogo from "../../assets/images/custom-field-banner.webp";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";
import { loadVendor, loadVendorPay } from "../../store/vendor/actions";
import {
  createVendorCategoryList,
  loadVendorCategory,
} from "../../store/vendor/actions";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import { toast, ToastContainer } from "react-toastify";

const VendorSupplier = (props) => {
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  //validator
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";
  const profileName =
    props.location && props.location.state
      ? props.location.state.user.organizations[0].organizationId
      : "";
  console.log(userId, "userId");

  const organizationId = !isEmpty(userInfoDetails)
    ? userInfoDetails
    : profileName;
  const itemList = { organizationId: organizationId };

  console.log(itemList, "itemList");
  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadVendor(itemList));
    dispatch(loadVendorPay(itemList));
    dispatch(loadVendorCategory(itemList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    vendor_list = [],
    vendor_pay_list = [],
    category_list = [],
  } = useSelector((state) => state.Vendor);

  // const { category_list = [] } = useSelector((state) => state.Items);

  const [vendorTab, setVendorTab] = useState("All Vendor");
  const [searchOpen, setSearchOpen] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);
  const [categoryAdditionalFields, setCategoryAdditionalFields] = useState("");

  const categoryOptions =
    category_list.length > 0
      ? category_list.map((c) => {
          return {
            label: c.categoryName,
            shortCode: c.shortCode,
            value: c._id,
          };
        })
      : [];
  //Custom Fields State values
  const [customFields, setCustomFields] = useState(false);
  // const [customFieldsAdd, setCustomFieldsAdd] = useState(false);
  const [pageRender, setPageRender] = useState(false);

  const handleOk = () => {
    setCustomFields(false);
  };
  const handleCancel = () => {
    setCustomFields(false);
  };

  const [customFieldsData, setCustomFieldsData] = useState([
    {
      fieldName: "",
    },
  ]);

  const addCustomFields = () => {
    setCustomFieldsData([
      ...customFieldsData,
      {
        fieldName: "",
      },
    ]);
    // setCustomFieldsAdd(true);
    setPageRender(!pageRender);
  };

  const removeCustomFields = (index) => {
    const array = customFieldsData;
    if (index !== 0) {
      if (index > -1) {
        array.splice(index, 1);
      }
    }
    setPageRender(!pageRender);
  };

  const handleCustomFieldsChange = (e, name, index) => {
    var fieldList = customFieldsData;
    if (name === "fieldName") {
      fieldList[index][name] = e.target.value;
      setCustomFieldsData(fieldList);
      setPageRender(!pageRender);
    }
  };

  const HeaderData = [
    {
      key: "name",
      title: <p className="parties-column-header font-semibold">Vendor Name</p>,
      sort: true,
      // render: (_, record) => `Group ${Math.floor(record.id / 4)}`,
      dataIndex: "vendorName",
    },
    {
      key: "displayName",
      title: (
        <p className="parties-column-header font-semibold">Display Name</p>
      ),
      sort: false,
      dataIndex: "displayName",
    },
    {
      key: "mobileNo",
      title: <p className="parties-column-header font-semibold">Mobile No</p>,
      sort: true,
      dataIndex: "mobileNo",
    },
    {
      key: "creditLimit",
      title: (
        <p className="parties-column-header font-semibold">Credit Limit</p>
      ),
      sort: false,
      dataIndex: "creditLimit",
    },
    // {
    //   key: "openingbalanceType",
    //   title: "Opening Balance Type",
    //   sort: false,
    //   dataIndex: "openingbalanceType",
    // },
    {
      key: "currentBalance",
      title: <p className="parties-column-header font-semibold">Balance</p>,
      sort: false,
      dataIndex: "currentBalance",
    },
  ];

  //row and data table section
  const [categoryName, setCategoryName] = useState("");
  const [description, setDescription] = useState("");
  const [shortCode, setShortCode] = useState("");
  const [itemCategory, setItemCategory] = useState([]);
  const [itemCategoryModal, setItemCategoryModal] = useState(false);
  const [vendorRows, setVendorRows] = useState([
    {
      vendorNameValue: "",
      categoryId: "",
      categoryName: "",
      vendorCode: "",
      billingAddress: "",
      _id: "",
      createdAt: "",
      createdBy: "",
      creditBalance: "",
      currentBalance: "",
      creditlimit: "",
      creditperiod: "",
      currencyId: "",
      currencyName: "",
      displayName: "",
      email: "",
      gstPercentageId: "",
      gstPercentageName: "",
      gstTypeName: "",
      mobileNo: "",
      openingBalance: "",
      openingbalanceType: "",
      PANNumber: "",
      GSTIN: "",
      vendorName: "",
      sourceofsupply: "",
      shippingAddress: "",
      status: "",
      updatedAt: "",
    },
  ]);

  const [search, setSearch] = useState("");

  const vendorRoutes = (data) => {
    history.push({
      pathname: "/vendor/data",
      state: {
        organizationId: organizationId,
        userId: userId,
        itemList: itemList,
        categoryOptions: categoryOptions,
        data: data,
      },
    });
  };

  //parties table filter based on tab selection
  const vendorFilteredData =
    vendorTab === "To Pay" && vendor_list && vendor_list.length > 0
      ? vendor_list.filter((data) => data.openingbalanceType === "To Pay")
      : [];

  const vendorDataTableList =
    vendorTab === "To Pay"
      ? vendorFilteredData
      : vendorTab === "All Vendor"
      ? vendor_list && vendor_list
      : [];

  const vendorDataTable =
    vendorDataTableList && vendorDataTableList.length > 0
      ? vendorDataTableList.map((data, index) => {
          return {
            index: index + 1,
            billingAddress: data.billingAddress,
            _id: data._id,
            createdAt: data.createdAt,
            createdBy: data.createdBy,
            creditBalance: data.creditBalance,
            // creditBalance: (
            //   <p onClick={() => vendorRoutes(data)} className="flex">
            //     <p className="mr-2">
            //       {data.openingbalanceType === "To Pay" ? (
            //         <ArrowDownOutlined className="text-[green]" />
            //       ) : (
            //         ""
            //       )}
            //     </p>{" "}
            //     {data.creditBalance ? data.creditBalance : "--"}
            //   </p>
            // ),
            currentBalance: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => vendorRoutes(data)}
                className="flex"
              >
                <p className="mr-2">
                  {/* {data.openingbalanceType === "To Pay" ? ( */}
                  <ArrowUpOutlined className="text-[red]" />
                  {/* ) : (
                    ""
                  )} */}
                </p>{" "}
                {data.currentBalance}
              </p>
            ),
            vendorName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => {
                  history.push({
                    pathname: "/vendor/data",
                    state: { data: data, categoryOptions: categoryOptions },
                  });
                }}
              >
                {data.vendorName ? data.vendorName : "--"}
              </p>
            ),
            creditlimit: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => vendorRoutes(data)}
              >
                {data.creditlimit ? data.creditlimit : "--"}
              </p>
            ),
            creditperiod: data.creditperiod,
            vendorNameValue: data.vendorName,
            currencyId: data.currencyId,
            currencyName: data.currencyName,
            displayName: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => vendorRoutes(data)}
              >
                {data.displayName ? data.displayName : "--"}
              </p>
            ),
            email: data.email,
            gstPercentageId: data.gstPercentageId,
            gstPercentageName: data.gstPercentageName,
            gstTypeName: data.gstTypeName,
            mobileNo: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => vendorRoutes(data)}
              >
                {data.mobileNo ? data.mobileNo : "--"}
              </p>
            ),
            openingBalance: data.openingBalance,
            openingbalanceType: (
              <p
                style={{
                  fontFamily: "Poppins",
                  fontSize: "13px",
                }}
                onClick={() => vendorRoutes(data)}
              >
                {data.openingbalanceType ? data.openingbalanceType : "--"}
              </p>
            ),
            PANNumber: data.PANNumber,
            GSTIN: data.GSTIN,
            placeofSupply: data.placeofSupply,
            categoryId: data.vendorCategoryId,
          categoryName: data.vendorCategoryName,
            shippingAddress: data.shippingAddress,
            status: data.status,
            updatedAt: data.updatedAt,
          };
        })
      : [];

  useEffect(() => {
    if (
      vendorDataTable &&
      vendorDataTable.length > 0 &&
      vendorTab === "All Vendor"
    ) {
      setVendorRows(vendorDataTable);
    } else if (vendorTab === "To Pay") {
      setVendorRows(vendorDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vendorTab, vendor_list]);
  //data table

  const handleSearch = (event) => {
    const filteredRows = vendorDataTable
      .filter((row) =>
        row.vendorNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setVendorRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //category api integrations
  const createCategory = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 6000);
      const categoryList = {
        categoryName: categoryName,
        organizationId: organizationId,
        shortCode: shortCode,
        description: description,
        createdBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
      };

      dispatch(createVendorCategoryList(categoryList));
      setTimeout(() => {
        dispatch(loadVendorCategory(itemList));
        setItemCategoryModal(false);
        toast.success("Category created successfully");
      }, 1000);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  useBeforeUnload({
    when: !isEmpty(itemCategory),
    message: "Are you sure you want to leave?",
  });

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Vendor | Mbook</title>
        </MetaTags>
      </div>
      <Row className="border-solid pb-[220px] rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-2">
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-2 font-semibold"
              >
                Vendor
              </h1>
            </div>
            <div className="flex">
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your vendor specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              <Tooltip
                title="Easily add custom fields to all your parties"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setCustomFields(true)}
                  className="border rounded-md ml-3 p-2.5 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        {/* </Skeleton.Input> */}
        <div
          className={
            windowDimensions.height >= 650 && windowDimensions.height < 700
              ? "vendor-home-tab-device-main-card"
              : (windowDimensions.height >= 700 &&
                  windowDimensions.height <= 767) ||
                (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "vendor-home-medium-device-main-card"
              : windowDimensions.height >= 800 && windowDimensions.height < 900
              ? "vendor-home-large-device-main-card"
              : windowDimensions.height >= 900 && windowDimensions.height < 1000
              ? "vendor-home-extra-large-device-main-card"
              : windowDimensions.height >= 1000
              ? "vendor-home-extra-infinite-large-device-main-card"
              : "vendor-home-main-card"
          }
        >
          <Col span={24} className="">
            <Row className="pl-5 mt-3 mb-5">
              {vendorHeaders.map((data) => {
                return (
                  <Col span={12} key={data.key} className="">
                    {loading ? (
                      <Skeleton.Input
                        style={{
                          marginRight: "5px",
                          minWidth: "255%",
                          height: "60px",
                        }}
                        // className="parties-card"
                        active={true}
                        size={"large"}
                        // block={true}
                      ></Skeleton.Input>
                    ) : (
                      <div
                        className={
                          vendorTab === data.label
                            ? "poppins mr-4 parties-select-card parties-card border rounded-md"
                            : data.key !== 3
                            ? "poppins mr-4 parties-card border rounded-md"
                            : "poppins parties-select-card parties-card border rounded-md"
                        }
                        onClick={() => {
                          setVendorTab(data.label);
                          setTableLoading(true);
                          setTimeout(() => {
                            setTableLoading(false);
                          }, 2000);
                        }}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            color: data.color,
                            fontFamily: "Poppins",
                          }}
                        >
                          <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                            {data.icon}
                          </p>
                          <h2 className={"ml-2"}>{data.label}</h2>
                        </div>
                        <div>
                          <h1 className="font-semibold text-[18px]">
                            {data.key == 1
                              ? vendorDataTable.length
                              : data.label === 3 &&
                                vendor_pay_list &&
                                vendor_pay_list.totalAmounttoPay !== undefined
                              ? "₹ " + vendor_pay_list.totalAmounttoPay
                              : "₹ " + 0}
                          </h1>
                        </div>
                      </div>
                    )}

                    {/* </Skeleton.Input> */}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* Parties input section with bulk actions */}
          <Col span={24}>
            <Row
              className={
                loading
                  ? "flex justify-between mt-1 ml-4 pr-8"
                  : "flex justify-between mt-1 ml-4"
              }
            >
              {loading ? (
                <Skeleton.Input
                  style={{
                    marginRight: "5px",
                    width: "100%",
                    height: "40px",
                  }}
                  active={true}
                  size={"large"}
                  // block={true}
                ></Skeleton.Input>
              ) : (
                <div className="flex">
                  <Tooltip
                    rootClassName="text-[10px]"
                    title="Search by phone or name"
                    placement="bottom"
                  >
                    {searchOpen ? (
                      <AutoComplete
                        style={{
                          width: 170,
                          marginRight: "10px",
                          fontFamily: "Poppins",
                        }}
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search vendor"
                          style={{
                            fontFamily: "Poppins",
                          }}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    ) : (
                      <div
                        onClick={() => setSearchOpen(true)}
                        className="border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                      >
                        <SearchOutlined size={16} />
                      </div>
                    )}
                  </Tooltip>
                  <Select
                    style={{
                      width: 250,
                      height: 40,
                    }}
                    value={itemCategory}
                    onChange={(e) => {
                      setItemCategory(e);
                      if (!isEmpty(e)) {
                        const filterRows =
                          vendorDataTable.length > 0 &&
                          vendorDataTable.filter((data) => data.categoryId === e);
                        console.log(filterRows, "filterRows");
                        const filteredData =
                          filterRows.length > 0 && filterRows;
                        setVendorRows(filteredData);
                        setTableLoading(true);
                        setTimeout(() => {
                          setTableLoading(false);
                        }, 1000);
                      }
                    }}
                    suffixIcon={
                      !isEmpty(itemCategory) ? (
                        <CloseCircleOutlined
                          onClick={() => {
                            setItemCategory([]);
                            setVendorRows(vendorDataTable);
                            setTableLoading(true);
                            setTimeout(() => {
                              setTableLoading(false);
                            }, 1000);
                          }}
                          className="text-[12px]"
                        />
                      ) : (
                        <SearchOutlined className="text-[12px]" />
                      )
                    }
                    onSearch={true}
                    placeholder="Select Categories"
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <div className="w-[100%]">
                          <Button
                            type="dashed"
                            className="w-[100%]"
                            icon={<PlusOutlined />}
                            onClick={() => setItemCategoryModal(true)}
                          >
                            Add item
                          </Button>
                        </div>
                      </>
                    )}
                    options={categoryOptions}
                  />
                </div>
              )}
              <div className="flex">
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "5px",
                      width: "100%",
                      height: "40px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={bulkActions}
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          pointerEvents: "none",
                          opacity: 1,
                        }}
                        className="border rounded-sm flex justify-between w-20px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                      >
                        <div>
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined />
                      </div>
                    </Tooltip>
                  </Popover>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginLeft: "15px",
                      width: "100%",
                      height: "40px",
                    }}
                    active={true}
                    size={"large"}
                    // block={true}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[blueviolet] p-5 text-[white] mr-3"
                  >
                    <Link
                      to={{
                        pathname: "/add-vendor-supplier",
                        state: {
                          organizationId: organizationId,
                          userId: userId,
                          itemList: itemList,
                          categoryOptions: categoryOptions,
                        },
                      }}
                    >
                      Create vendor
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pt-3 pb-3 pr-4 pl-4 mb-[70px]">
            <Table
              style={{
                overflow: "hidden",
                cursor: "pointer",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                vendorRows &&
                vendorRows.length > 0 &&
                !isEmpty(vendorRows[0].vendorNameValue)
                  ? vendorRows
                  : []
              }
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              // onHeaderRow={}
              loading={tableLoading ? true : false}
              rowKey={(record) => record._id}
              scroll={{
                y:
                  vendorRows.length < 3
                    ? 150
                    : vendorRows.length > 3
                    ? "100%"
                    : "",
                x: 765,
              }}
              showSorterTooltip={"sorter-icon"}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={customFields}
          title="Add Custom Fields"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: customFieldsData.length > 0 ? false : true,
          }}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <div className="w-[110%] ml-[-23.5px] mt-[-24px] mb-4">
            <Image src={customModalLogo} />
          </div>
          <div>
            <Typography className="mb-2">Field Name</Typography>
            {customFieldsData.map((data, index) => {
              return (
                <div key={index} className="mb-2">
                  <div className="flex justify-between mb-[10px]">
                    <Input
                      name="fieldName"
                      value={data.fieldName}
                      placeholder="Enter Custom Field name"
                      className="w-[90%]"
                      onChange={(e) =>
                        handleCustomFieldsChange(e, "fieldName", index)
                      }
                    />
                    <DeleteOutlined
                      onClick={() => removeCustomFields(index)}
                      type="primary"
                      className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                      size={"large"}
                    />{" "}
                  </div>
                </div>
              );
            })}
          </div>
          {/* ) : (
            ""
          )} */}

          <Row
            onClick={() => addCustomFields()}
            className="w-[100%] mt-2 bg-gray-50 p-2 border border-dashed border-blue-400 pl-5 pr-5 mt-3 mb-3"
          >
            <h1 className="cursor-pointer text-[14px] text-[#084d7b] font-semibold">
              {" "}
              <PlusOutlined /> Add Custom Field
            </h1>
          </Row>
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
        <Modal
          open={pageRouting}
          onOk={() => {
            setPageRouting(false);
            history.push("/dashboard");
          }}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Leave"}
          cancelText={"No, Stay"}
          onCancel={() => setPageRouting(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <div className="mr-3">
                <OkBtn />
              </div>
              <CancelBtn />
            </div>
          )}
          width={500}
        >
          <div className="text-center w-[100%]">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to leave this page?
            </h1>
            <p className="text-center text-[14px] mt-2">
              All unsaved changes will be lost!
            </p>
          </div>
        </Modal>
      </Row>
      <Prompt
        when={!isEmpty(itemCategory)}
        message="Are you sure you want to leave?"
      />
      {/* New category modal */}
      <Modal
        open={itemCategoryModal}
        title={"Create Category"}
        onOk={() => {
          createCategory();
        }}
        closeIcon
        maskClosable={false}
        okText={"Save"}
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        width={450}
        onCancel={() => setItemCategoryModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <Divider
          style={{
            borderWidth: "0.2px",
            marginTop: "1px",
            width: "112%",
            marginLeft: "-24px",
          }}
        />
        <Col span={24} className="mt-[-5px]">
          <Typography
            className="uppercase mb-1"
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
            }}
          >
            Category Name
          </Typography>
          <Input
            name="categoryName"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter Category Name"
            className="p-2"
          />
          <p className="text-start text-[red] mt-2 mb-3">
            {simpleValidator.current.message(
              "categoryName",
              categoryName,
              "required"
            )}
          </p>
        </Col>
        {categoryAdditionalFields ? (
          <>
            {" "}
            <Col span={24} className="flex justify-end">
              <div
                style={{
                  fontFamily: "Poppins",
                }}
                onClick={() => setCategoryAdditionalFields(false)}
                className="cursor-pointer text-[#d54041] text-[13px]"
              >
                Remove
              </div>
            </Col>
            <Col span={24}>
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Short Code
              </Typography>
              <Input
                name="shortCode"
                value={shortCode}
                onChange={(e) => setShortCode(e.target.value)}
                placeholder="Enter Short Code"
                className="p-2"
              />
            </Col>
            <Col span={24} className="mb-[50px] mt-2">
              <Typography
                className="uppercase mb-1"
                style={{
                  fontFamily: "Poppins",
                  fontSize: "12px",
                }}
              >
                Description
              </Typography>
              <Input.TextArea
                name="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter Description"
                className="p-3"
              />
            </Col>
          </>
        ) : (
          <div
            style={{
              fontFamily: "Poppins",
            }}
            onClick={() => setCategoryAdditionalFields(true)}
            className="cursor-pointer flex text-[#4096ff] mt-2 text-[13px] mb-4"
          >
            <PlusOutlined className="mr-2" /> Additonal Fields
          </div>
        )}
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{
          fontSize: "12px",
        }}
      />
    </React.Fragment>
  );
};

VendorSupplier.propTypes = {
  location: PropTypes.any,
};

export default VendorSupplier;
